// How the page shows a record's ID: small and grey, so it is at hand without competing with the name
export const ID_TEXT_CLASS = 'font-mono text-xs text-text-muted';
